import { get } from 'lodash-es';

const byCompanyName = (state: any) => get(state, 'expose.view.companyName');

export default byCompanyName;
